import React, { useEffect } from "react";
import ReactLoading from "react-loading";
import { useLocation } from "react-router-dom";
import { sendWelcomeEmail, verifyEmailToken } from "../../utils/services/emailService";
import History from "../../utils/services/GlobalNavigation/navigationHistory";
import { isLogin } from "../../utils/services/auth";
import { notify } from "../../utils/services/notification";

function MailVerification(): JSX.Element {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const paramValue: any = queryParams.get("token");
  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
      (async () => {
        const response = await verifyEmailToken(paramValue);
        if (response?.status === 200) {
          notify("Email Verified Succesfully", "success");
          isLogin() && History.navigate("/dashboard");
          sendWelcomeEmail()
        } else {
          History.navigate("/");
        }
      })();
    }
    return () => {
      componentMounted = false;
    };
  }, []);

  return (
    <div className="loadingContainer">
      <ReactLoading
        type={"bubbles"}
        color={"#4452FE"}
        height={667}
        width={375}
      />
    </div>
  );
}

export default MailVerification;
